import { render, staticRenderFns } from "./FAQList.vue?vue&type=template&id=2eed7f86&scoped=true&"
import script from "./FAQList.vue?vue&type=script&lang=js&"
export * from "./FAQList.vue?vue&type=script&lang=js&"
import style0 from "./FAQList.vue?vue&type=style&index=0&id=2eed7f86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eed7f86",
  null
  
)

export default component.exports